import type { ReactNode } from 'react';

export const symbol_network_check: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M32-569q-14-14-13-32.5T34-633q45-39 97-70t109-53q66-26 136-36t141-7q19 1 31 14.5t10 32.5q-2 19-15.5 31T510-710q-60-2-118.5 6.5T276-674q-49 19-92.5 44.5T98-568q-14 13-33 13t-33-14Zm187 127q-20 14-37.5 10.5T153-448q-11-13-11.5-30.5T157-508q63-46 137.5-73T448-611q20-1 30.5 12t11.5 30q1 17-9.5 31.5T446-521q-62 6-119.5 25T219-442Zm225 278q-29-11-40.5-41.5T406-264l237-490q3-7 10.5-10t15.5-1q8 2 13 9t3 15L547-206q-8 29-39.5 42t-63.5 0Zm484-409q-11 13-29 16t-38-13q-22-18-50.5-37.5T757-641q-19-11-22-29t5-32q8-14 24-21t36 3q31 16 65.5 40.5T926-633q15 13 14 30t-12 30ZM804-409q-19 3-38-14-11-10-26-19.5T712-459q-21-11-25-29t4-33q8-15 23-22.5t33 .5q21 10 43.5 26t40.5 30q17 14 15.5 31.5T834-425q-11 13-30 16Z"
		/>
	</svg>
);
